import { handleDom } from './handleDom.js';
import { handleScope } from './handleScope.js';

function breadcrumbHandler(type, handlerData) {
  if (type === 'scope') {
    return handleScope(handlerData );
  }

  return handleDom(handlerData );
}

export { breadcrumbHandler };
//# sourceMappingURL=breadcrumbHandler.js.map
